<template>
  <div class="page_part5">
    <div class="page_mulu content">
      <div class="linebox" >
<!--        <p class="line_info">你在职业价值观上的测评得分如下图所示：</p>-->
        <div id="lineTu"></div>
        <div class="echarts_com" >
          <div class="com_left">
            <p>你的主职业锚是：<span>{{profession.main}}</span></p>
          </div>
          <div class="com_right" v-if="profession.deputy">
            <p>你的副职业锚是：<span>{{profession.deputy[0]}}和{{profession.deputy[1]}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts2 from "echarts";

export default {
  props:{
    // hobby:{
    //   type:Object
    // },
    // threeCategory:{
    //   type:Array
    // },
    profession:{
      type:Object
    }
  },
  data() {
    return {
      options:{},
      radarChart:[],
      bgArr:[],
      norm:{},
      updata:true,
      arr:[],
      bool:true,
      Data:'',
      radarZhuData:[],
      radarZhuVal:[]
    };
  },
  created() {
  },
  mounted() {
  },
  updated(){

  },
  watch:{
    profession(newval,oldval){
      this.Data = newval.data; // 柱状图
      for (var i = 0; i < this.Data.length; i++) {
        this.radarZhuData.push(this.Data[i].name);
        this.radarZhuVal.push(this.Data[i].value);
      }
      this.drawBagua(this.radarZhuVal)
    }
  },
  methods: {
    draw(){
     
    },
    drawBagua(data) {
      var bkData = [100, 100, 100, 100, 100, 100, 100, 100];
      let  echarts = require("echarts");
      var myChart3 = echarts.init(document.getElementById("lineTu"));
      myChart3.setOption({
        backgroundColor: "",
        color: ["#3398DB"],
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "rgb(7,55,133)",
          borderColor: "#0daee9",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true, // 坐标轴两边留白
            gridIndex: 0,
            data: this.radarZhuData,
            axisLabel: {
              textStyle: {
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,.8)",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name: "分值",
            type: "value",
            nameTextStyle: {
              color: "rgb(170,170,170)",
            },
            gridIndex: 0,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(224, 222, 222, 1)",
              },
            },
            axisLabel: {
              color: "rgba(0,0,0,.8)",
              fontSize: 12,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(224, 222, 222, 1)",
              },
            },
          },
          {
            type: "value",
            show: false,
            gridIndex: 0,
            // min: min,
            // max: 6,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#95a2aa",
              fontSize: 14,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
        ],
        series: [
          {
            // name: "高发事件统计",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 0,
            itemStyle: {
          
                color:function(params){
                function f(a,b){
                  return - (a-b)
                }
                data.sort(f)
              
                if(data[0] == params.value){
                  return "#FEAE3B"
                }else if(data[1] == params.value){
                  return "#1CA4B6"
                }else if(data[2] == params.value){
                  return "#1CA4B6"
                }else {
                  return "#C5E419"
                }
              }
            },
            label: {
              show: true,
              position: "top",
            },
            data: data,
            zlevel: 11,
          },
          {
            name: "背景",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-100%",
            data: bkData,
            itemStyle: {
              normal: {
                color: "rgba(0,162,255,0.1)",
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            tooltip: {
              show: false,
            },
            zlevel: 9,
          },
        ],
      });
      
  
        
    },
  },
};
</script>

<style scoped>
@import './report.css';
#lineTu {
  width: 100%;
  height: 400px;
}
#Gossip {
  width: 100%;
  height: 600px;
}
.jie_list {
  width: 100%;
  /* height: 252px; */
  border: 1px dashed #e6e6e6;
  border-radius: 6px 6px 0px 0px;
  background: #f6f6f6;
  padding: 0 15px 15px;
  box-sizing: border-box;
  margin-top: 30px;
}
.jie_list p.jie_title {
  font-size: 14px;
  font-weight: 400;
  color: #2f2f2f;
  height: 44px;
  line-height: 44px;
  border-bottom: 1px dashed #e6e6e6;
}
.jie_list .jie_title span {
  font-size: 16px;
  color: #1ca4b6;
  font-weight: 600;
}
.jie_mian p {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  margin-top: 15px;
}
.jie_mian ul li {
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  color: #9e9e9e;
}

.result {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.result_left,
.result_right {
  width: 315px;
  height: 40px;
  background: #f6f6f6;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
}
.result_left p span {
  font-size: 20px;
  color: #1ca4b6;
  vertical-align: top;
}
.result_right p span {
  font-size: 20px;
  color: #f6a724;
  vertical-align: top;
}


h5.page_bg_o {
  background-color: #feae3b;
}

h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin: 30px 0 15px 0;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 20px 0 10px 0;
}
.page_part2 .page_title_2 .arrow {
}
h5.page_bg_bl {
  background-color: #1ca4b6;
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  /* border-left: 14px solid #feae3b; */
  border-left: 14px solid #19b1c4;
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin: 40px 0 20px 0;
}

.jie_bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.jie_left {
  width: 334px;
  height: 163px;
  background: url("/public/imgs/cepingreport/page_3_33.png")
  no-repeat;
  background-size: cover;
  padding: 15px;
  box-sizing: border-box;
}
.jie_right {
  width: 334px;
  height: 163px;
  background: url("/public/imgs/cepingreport/page_3_34.png")
  no-repeat;
  background-size: cover;
  padding: 15px;
  box-sizing: border-box;
}
.jie_left p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 2;
}
.jie_left p:first-child span {
  font-size: 16px;
  color: #ffc002;
  font-weight: 600;
  margin-left: 10px;
}
.jie_left p:last-child {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 1.5;
}
.jie_right p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 2;

}
.jie_right p:first-child span {
  font-size: 16px;
  color: #28dfa0;
  font-weight: 600;
  margin-left: 10px;
}
.jie_right p:last-child {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 1.5;
}
.bgfont{
  background: #f6a724;
}
.bgfont2{
  background: #1CA4B6;
}
.bgfont3{
  background: #1CA4B6;
}

.linebox .line_info{
  font-size: 14px;
  font-weight: 400;
  color: #B0B0B0;
  margin: 15px 0;
}
.echarts_com{
  display: flex;
  justify-content: space-between;
}
.com_left,.com_right{
  width: 311px;
  height: 40px;
  background: #F6F6F6;
  border-radius: 6px;
  line-height: 40px;
  text-align: center;
}
.com_left p,.com_right p{
  font-size: 14px;
  color: #2F2F2F;
}

.com_left p span{
  color: #1CA4B6;
  font-size: 16px;
  font-weight: 600;
}
.com_right p span{
  color: #FEAE3B;
  font-size: 16px;
  font-weight: 600;
}
.page_js{
  margin-bottom: 60px;
  height: auto;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 30px 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
.page_js .page_bg_o{
  background: #FEAE3B;
}
.page_js .page_bg_bl{
  background: #00B3F0;
}
.page_js .page_bg_g{
  background: #AACF00;
}
.page_zyjs{
  width: auto;
  padding: 0 15px;
  height: 30px;
  /* background: #3AB3C1; */
  border-radius: 6px;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  top: -15px;
}
.page_js ul li{
  text-indent: 2em;
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
</style>